import r from"antd/lib/message";var n=function(n,o){(0,{error:r.error,warning:r.warning,success:r.success,info:r.info}[o.type])(n,o.duration)};export{n as showMessage};
